module.exports = ".modal-dialog {\r\n\twidth: 100%;\r\n}\r\n\r\n.modal-body {\r\n\toverflow: visible;\r\n}\r\n"